export const Languages = [
    { id: "en-US", description: "English" },
    { id: "fr-CA", description: "French" }
] as const;

export type LanguageKey = (typeof Languages)[number]["id"];

export const LanguageIds = Languages.map(l => l.id) as [LanguageKey, ...LanguageKey[]];

export type LocalizedText = Record<LanguageKey, string>;

export function resolveLanguageKey(acceptLanguage: string | undefined): LanguageKey {
    return acceptLanguage?.toLowerCase().startsWith("fr") ? "fr-CA" : "en-US";
}

export function isSupportedLanguage(value: string): value is LanguageKey {
    return LanguageIds.some(id => id === value);
}
